import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static targets = [
        "dayWrapper",
        "statusWrapper",
        "colorWrapper",
    ]

    declare readonly dayWrapperTarget: HTMLElement
    declare readonly hasDayWrapperTarget: boolean

    declare readonly statusWrapperTarget: HTMLElement
    declare readonly hasStatusWrapperTarget: boolean

    declare readonly colorWrapperTarget: HTMLElement
    declare readonly hasColorWrapperTarget: boolean

    connect(): void {

        this.refresh()

        const typeSelect =
            document.querySelector(
                '#tag_type'
            ) as HTMLSelectElement

        if (!typeSelect) {
            return
        }

        typeSelect.addEventListener(
            'change',
            () => this.refresh()
        )
    }

    refresh(): void {

        const typeSelect =
            document.querySelector(
                '#tag_type'
            ) as HTMLSelectElement

        if (!typeSelect) {
            return
        }

        const text =
            typeSelect.selectedOptions[0]
                ?.textContent
                ?.toLowerCase() || ''

        const isSchedule =
            text.includes('horario')

        // =========================
        // SHOW/HIDE
        // =========================

        if (this.hasDayWrapperTarget) {
            this.dayWrapperTarget.classList.toggle('d-none', !isSchedule)
        }

        if (this.hasStatusWrapperTarget) {
            this.statusWrapperTarget.classList.toggle('d-none', !isSchedule)
        }

        // Hide color field when a type is selected (type provides its own color)
        const hasType = typeSelect.value !== ''
        if (this.hasColorWrapperTarget) {
            this.colorWrapperTarget.classList.toggle('d-none', hasType)
        }

        // =========================
        // READONLY SCHEDULE
        // =========================

        const nameInput =
            document.querySelector(
                '#tag_name'
            ) as HTMLInputElement

        if (nameInput) {

            nameInput.readOnly =
                isSchedule
        }

        // =========================
        // AUTO NAME
        // =========================

        if (isSchedule) {

            const day =
                (
                    document.querySelector(
                        '#tag_day'
                    ) as HTMLSelectElement
                )?.value || ''

            const status =
                (
                    document.querySelector(
                        '#tag_scheduleStatus'
                    ) as HTMLSelectElement
                )?.selectedOptions[0]
                    ?.textContent || ''

            if (day && status) {

                nameInput.value = status
            }
        }
    }
}
